import React from "react";
import ReactSelect from "react-select";
import { useDevicePixelRatio } from "helpers/hooks";

const Select = (props) => {
  const dpr = useDevicePixelRatio();
  const dprz = dpr === 1.25 || dpr === 2;
  const {
    option = [],
    value = null,
    name = "",
    onChange,
    placeholder = "",
    isMulti = false,
    isMenuOpen = false,
    autoHeight = false,
    newStyle = null,
  } = props;

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      padding: dprz ? 0 : "10px",
      width: "100%",
      height: autoHeight ? "auto" : dprz ? "33px" : "44px",
      borderRadius: "4px",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "normal",
      minHeight: "44px",
      border: state.menuIsOpen || isMenuOpen ? "1px solid #FB6906" : "1px solid #D9D9D9",
      boxShadow: "0 0 0 1px #fff",
      cursor: "pointer",

      ":hover": {
        borderColor: state.menuIsOpen || isMenuOpen ? "#FB6906" : "#D9D9D9",
      },
      ":focus": {
        border: "1px solid #D9D9D9",
        borderRadius: "4px",
      },
    }),
    placeholder: (styles, { data }) => {
      return {
        ...styles,
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: dprz ? "14px" : "14px",
        color: "#7E7E7E",
        top: autoHeight ? "50%" : "54%",
      };
    },
    indicatorSeparator: (styles) => ({
      ...styles,
      display: "none",
    }),
    valueContainer: (styles, data) => ({
      ...styles,
      padding: dprz ? "0 10px 0 10px" : "10px",
      position: "static",
      marginTop: dprz ? "0" : "-13px",
      maxHeight: dprz ? "33px" : "44px",
      fontSize: dprz ? "12px" : "16px",
      flexWrap: "nowrap",
    }),
    multiValue: (styles, state) => ({
      ...styles,
      display: "none",
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      marginTop: autoHeight ? "0" : dprz ? "-2px" : "-12px",
      color: "#1C1B1F",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: "#1C1B1F",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 999 }),
    input: (base) => ({
      ...base,
      marginTop: dprz ? "0px" : "2px",
      width: "100% !important",
    }),
    menu: (base) => ({
      ...base,
      fontSize: dprz ? "12px" : "16px",
    }),
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "6px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    option: (base) => ({ ...base }),
  };

  return (
    <ReactSelect
      name={name}
      options={option}
      onChange={onChange}
      placeholder={placeholder}
      styles={newStyle ?? customStyle}
      isMulti={isMulti}
      value={value}
      {...props}
    />
  );
};

export default Select;
